import React from "react";
import { useHistory } from "react-router-dom";
import { Button, Chip, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  CheckCircle,
  CropFree,
  Error as ErrorIcon,
  Sync,
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1.5, 2),
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: theme.spacing(1),
  },
  label: {
    fontWeight: 600,
    marginRight: theme.spacing(0.5),
  },
  spacer: { flex: 1 },
  chip: {
    fontWeight: 600,
    "& .MuiChip-icon": { color: "inherit" },
  },
}));

const STATUS = {
  CONNECTED: { label: "Conectado", tone: "good", Icon: CheckCircle },
  qrcode: { label: "Aguardando QR Code", tone: "warning", Icon: CropFree },
  OPENING: { label: "Conectando", tone: "warning", Icon: Sync },
  PAIRING: { label: "Conectando", tone: "warning", Icon: Sync },
};
const DISCONNECTED = { label: "Desconectado", tone: "critical", Icon: ErrorIcon };

export default function ConnectionsStatus({ connections = [] }) {
  const classes = useStyles();
  const history = useHistory();

  if (!connections.length) return null;

  const toneColor = (theme, tone) => {
    const map = {
      good: theme.palette.success.main,
      warning: theme.palette.warning.main,
      critical: theme.palette.error.main,
    };
    return map[tone];
  };

  const hasProblem = connections.some((c) => c.status !== "CONNECTED");

  return (
    <Paper className={classes.root} variant="outlined">
      <Typography variant="body2" className={classes.label}>
        Conexões WhatsApp:
      </Typography>
      {connections.map((c) => {
        const info = STATUS[c.status] || DISCONNECTED;
        const { Icon } = info;
        return (
          <ChipWithTone
            key={c.id}
            className={classes.chip}
            icon={<Icon fontSize="small" />}
            label={`${c.name} · ${info.label}`}
            tone={info.tone}
            toneColor={toneColor}
          />
        );
      })}
      <span className={classes.spacer} />
      {hasProblem && (
        <Button size="small" color="primary" onClick={() => history.push("/connections")}>
          Ver conexões
        </Button>
      )}
    </Paper>
  );
}

const useChipStyles = makeStyles((theme) => ({
  chip: ({ tone, toneColor }) => {
    const color = toneColor(theme, tone);
    return {
      color,
      backgroundColor: `${color}1f`,
      border: `1px solid ${color}55`,
    };
  },
}));

function ChipWithTone({ tone, toneColor, className, ...props }) {
  const classes = useChipStyles({ tone, toneColor });
  return <Chip size="small" className={`${className} ${classes.chip}`} {...props} />;
}
